import clsx from 'clsx';

import Grid, { type GridProps, type GridSize } from '@commons/containers/Grid';
import PageBuilder from '@commons/pagebuilder';

import type { DrupalInsightsView } from '.';
import styles from './FeaturedTiles.module.scss';

/**
 * Featured tiles display of the insights view.
 *
 * Renders a set of insights as featured tiles.
 * On mobile, the content overflows to the right.
 *
 * Used in many contexts, like for the solution / capability / platform pages.
 */

const FeaturedTilesDisplay = ({ content, settings }: DrupalInsightsView) => {
  const limit = settings.limit ? parseInt(settings.limit, 10) : 2;

  const columns: GridProps['columns'] = (limit >= 2 ? 2 : limit) as GridSize;

  return (
    <Grid gap="md" columns={columns} className={clsx(styles.insights, 'w-100')}>
      {content.map(PageBuilder.renderNode)}
    </Grid>
  );
};

export default FeaturedTilesDisplay;
